import React, { useState, useContext } from 'react';
import { AppContext } from 'contexts';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { submitLeadRequest } from 'utils';
import { isEmailValid } from 'utils/validators';
import { images } from 'images';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { startsWith } from 'lodash';
import {
  makeStyles,
  Modal,
  Typography,
  TextField,
  IconButton,
  Button,
} from '@material-ui/core';
import { HvAlert } from 'components';

const useStyles = makeStyles((theme) => {
  return {
    chatModal: {
      width: 440,
      position: 'relative',
      top: '20%',
      borderRadius: 8,
      marginLeft: 'auto',
      marginRight: 'auto',
      alignContent: 'center',
      backgroundColor: 'white',
      animation: 'slide-down .2s ease-in',
      '@media (max-width: 767px)': {
        top: 101,
        width: 330,
      },
    },
    titleContent: {
      borderRadius: '8px 8px 0 0',
      paddingTop: 20,
      paddingBottom: 20,
      width: '100%',
      textAlign: 'left',
      backgroundColor: '#00bdf2',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title: {
      fontSize: 20,
      fontFamily: 'FordAntenna-SemiBold',
      color: 'white',
      marginLeft: 20,
      '@media (max-width: 767px)': {
        fontSize: 18,
      },
    },
    icon: {
      color: 'white',
      width: 30,
      height: 30,
    },
    inputsContent: {
      padding: 20,
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
    },
    input: {
      marginBottom: 10,
    },
    button: {
      backgroundColor: '#00bdf2',
      width: '100%',
      color: 'white',
      '&:hover': {
        backgroundColor: '#00bdf2',
      },
    },
    buttonText: {
      fontFamily: 'FordAntenna-Medium',
    },
    description: {
      fontSize: 17,
      fontFamily: 'FordAntenna-SemiBold',
    },
    image: {
      width: 210,
      height: 210,
      alignSelf: 'center',
      marginTop: 10,
      marginBottom: 10,
      '@media (max-width: 767px)': {
        width: 150,
        height: 150,
      },
    },
    error: {
      color: 'red',
      fontSize: 12,
    },
    form: {
      marginBottom: 15,
    },
  };
});
function ChatModal() {
  const appContext = useContext(AppContext);
  const classes = useStyles();
  const { listing, displayChatModal, setDisplayChatModal, setAlert } = appContext;
  const city = listing ? listing.city : '';
  const address = listing ? listing.address : '';
  const appartement = listing && listing.app ? `${listing.app}-` : '';

  const [formData, setFormData] = useState({
    email: '',
    phone_number: '',
  });
  const [errors, setErrors] = useState({
    email: false,
    phone_number: false,
  });
  const [emptyFields, setEmptyFields] = useState(false);
  const handleInputChange = (event) => {
    setEmptyFields(false);
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    if (name === 'email') {
      if (!value) {
        setErrors({ ...errors, email: false });
      }
    }
  };

  const onCloseModal = () => {
    setDisplayChatModal(false);
    setFormData({
      email: '',
      phone_number: '',
    });
    setErrors({
      email: false,
      phone_number: false,
    });
    setEmptyFields(false);
  };
  const handleEmailValidation = () => {
    if (formData.email && !isEmailValid(formData.email)) {
      setErrors({ ...errors, email: true });
    } else {
      setErrors({ ...errors, email: false });
    }
  };
  const validatePhoneNumber = (inputNumber, country, countries) => {
    return countries.some(() => {
      return (
        startsWith(inputNumber, country.dialCode) ||
        startsWith(country.dialCode, inputNumber)
      );
    });
  };
  const validatePhoneNumberLength = () => {
    if (
      formData.phone_number !== null &&
      formData.phone_number.length < 12 &&
      formData.phone_number.length !== 2
    ) {
      setErrors({ ...errors, phone_number: true });
      return false;
    }
    setErrors({ ...errors, phone_number: false });
    return true;
  };
  const checkIfPhoneValid = () => {
    return (
      formData.phone_number !== null &&
      (formData.phone_number.length === 2 || formData.phone_number.length === 12) &&
      !errors.phone_number
    );
  };
  const onChangePhoneNumber = (phone) => {
    setEmptyFields(false);
    setFormData({ ...formData, phone_number: `+${phone}` });
  };
  const onSend = async (e) => {
    const { email, phone_number } = formData;
    e.preventDefault();
    let can_proceed = false;
    if (!email && !phone_number) {
      can_proceed = false;
      setEmptyFields(true);
    } else {
      can_proceed =
        (email && isEmailValid(email)) || (phone_number && checkIfPhoneValid());
    }
    const validationErrors = {
      email: false,
      phone_number: false,
    };
    if (email && !isEmailValid(email)) {
      validationErrors.email = true;
    }
    if (phone_number && !checkIfPhoneValid()) {
      validationErrors.phone_number = true;
    }
    setErrors(validationErrors);
    if (can_proceed) {
      let data = formData;
      if (listing.broker.id) {
        data = {
          ...formData,
          ...{
            destinate_user_id: Number(listing.broker.id),
            data: JSON.stringify({
              message: `Demander des informations sur ${appartement}${address} ${city}`,
            }),
          },
          ...{
            firstname: 'Client',
            lastname: 'Visite virtuelle',
          },
        };
        if (phone_number.length === 12 && checkIfPhoneValid()) {
          data.phone_number = phone_number;
        }
        data.email = email || 'N/A';
      }
      const res = await submitLeadRequest(data);
      if (res.status === 200) {
        setDisplayChatModal(false);
        setAlert('success', 'Message envoyé avec succès');
        setFormData({
          email: '',
          phone_number: '',
        });
        setErrors({
          email: false,
          phone_number: false,
        });
        setEmptyFields(false);
      } else {
        setAlert('error', "Erreur lors de l'envoi du message");
      }
    }
  };

  const { email, phone_number } = formData;
  return (
    <div>
      <HvAlert />
      <Modal open={displayChatModal} onClose={onCloseModal}>
        <div className={classes.chatModal}>
          <div className={classes.titleContent}>
            <Typography className={classes.title}>Restons en contact</Typography>
            <IconButton onClick={onCloseModal}>
              <CloseRoundedIcon className={classes.icon} />
            </IconButton>
          </div>
          <div className={classes.inputsContent}>
            <Typography className={classes.description}>
              Trouvez votre maison de rêve plus rapidement
            </Typography>
            <img src={images.house_alert} className={classes.image} alt='house' />
            <form className={classes.form}>
              <TextField
                id='email'
                label='Courriel'
                className={classes.input}
                name='email'
                variant='outlined'
                size='small'
                error={errors.email}
                fullWidth
                value={email}
                onChange={handleInputChange}
                onBlur={handleEmailValidation}
                helperText={errors.email ? 'Veuillez entrer un email valide' : null}
              />
              <PhoneInput
                country='ca'
                preferredCountries={['ca', 'us']}
                enableSearch
                value={phone_number}
                inputProps={{
                  name: 'Numéro de téléphone',
                  required: true,
                }}
                prefix='+'
                countryCodeEditable={false}
                onChange={(phone) => {
                  return onChangePhoneNumber(phone);
                }}
                onBlur={(e) => {
                  if (phone_number !== null) {
                    return validatePhoneNumberLength();
                  }
                  setErrors({ ...errors, phone_number: false });
                  return null;
                }}
                isValid={(inputNumber, country: any, countries) => {
                  return validatePhoneNumber(inputNumber, country, countries);
                }}
                defaultErrorMessage='Numéro de téléphone invalide'
                inputStyle={{ margin: 0, width: '100%', height: 40 }}
              />
              {errors.phone_number ? (
                <Typography className={classes.error}>
                  Numéro de téléphone invalide
                </Typography>
              ) : null}
              {emptyFields ? (
                <Typography className={classes.error}>
                  Veuillez entrer un email ou un numéro de téléphone
                </Typography>
              ) : null}
            </form>
            <Button className={classes.button} onClick={onSend}>
              <Typography className={classes.buttonText}>Envoyer</Typography>
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
export default ChatModal;
